import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "./api";
import { useAuth } from "./auth";

const ReleaseCtx = createContext({ enabled: null, environment: "", refresh: () => {} });

export function ReleaseProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({ enabled: null, environment: "" });

  const refresh = useCallback(async () => {
    if (!user) { setState({ enabled: null, environment: "" }); return; }
    try {
      const { data } = await api.get("/release/flags");
      setState({ enabled: new Set(data.enabled), environment: data.environment });
    } catch {
      setState({ enabled: new Set(), environment: "" });
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ReleaseCtx.Provider value={{ ...state, refresh }}>{children}</ReleaseCtx.Provider>
  );
}

/** `loading` is true until the switches are known, so nothing flashes before it is hidden. */
export function useRelease() {
  const { enabled, environment, refresh } = useContext(ReleaseCtx);
  return {
    loading: enabled === null,
    environment,
    refresh,
    isOn: (key) => (enabled === null ? false : enabled.has(key)),
  };
}
